export default "__VITE_ASSET__c2fb80e8__"